import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

let cmcoords = false;
let cmhello = false;
let outputElement = document.getElementById("output") as HTMLTextAreaElement;

function ex_addContextMenuItem1() {
  if (outputElement) {
    if (cmcoords == false) {
      LwAPI?.addContextMenuItem("Print 2D coordinates", (pt2) => {
        outputElement.value =
          outputElement.value +
          "\n************\n" +
          "Right click at (" +
          pt2["x"] +
          ";" +
          pt2["y"] +
          ")";
      });
      cmcoords = true;
      outputElement.value =
        outputElement.value +
        "\n************\n" +
        "Item 'Print 2D coordinates' added to context menu";
    } else {
      outputElement.value =
        outputElement.value +
        "\n************\n" +
        "This menu item has already been added.";
    }
  }
}

function ex_addContextMenuItem2() {
  if (outputElement) {
    if (cmhello == false) {
      LwAPI?.addContextMenuItem("Say hello", () => {
        alert("Hello");
      });
      cmhello = true;
      outputElement.value =
        outputElement.value +
        "\n************\n" +
        "Item 'Say hello' added to context menu";
    } else {
      outputElement.value =
        outputElement.value +
        "\n************\n" +
        "This menu item has already been added.";
    }
  }
}

// Bind functions to buttons
document.getElementById("add1")?.addEventListener("click", async () => {
  await apiReady;
  ex_addContextMenuItem1();
});
document.getElementById("add2")?.addEventListener("click", async () => {
  await apiReady;
  ex_addContextMenuItem2();
});
